import type { ComponentType } from "preact";

import { AppleMusic } from "../components/brand/appleMusic";
import { Deezer } from "../components/brand/deezer";
import { Facebook } from "../components/brand/facebook";
import { Instagram } from "../components/brand/instagram";
import { LastFm } from "../components/brand/lastFm";
import { MusicBrainz } from "../components/brand/musicBrainz";
import { Soundcloud } from "../components/brand/soundcloud";
import { Spotify } from "../components/brand/spotify";
import { Tidal } from "../components/brand/tidal";
import { TikTok } from "../components/brand/tiktok";
import { Unkown } from "../components/brand/unkown";
import { Wikipedia } from "../components/brand/wikipedia";
import { X } from "../components/brand/x";
import { YouTube } from "../components/brand/youtube";

export function getLinkIcon(url: string): {
  Icon: ComponentType<{ className?: string }>;
  label: string;
} {
  if (url.includes("instagram")) return { Icon: Instagram, label: "Instagram" };
  if (url.includes("facebook")) return { Icon: Facebook, label: "Facebook" };
  if (url.includes("twitter") || url.includes("x.com"))
    return { Icon: X, label: "X" };
  if (url.includes("tiktok")) return { Icon: TikTok, label: "TikTok" };
  if (url.includes("soundcloud"))
    return { Icon: Soundcloud, label: "SoundCloud" };
  if (url.includes("spotify")) return { Icon: Spotify, label: "Spotify" };
  if (url.includes("apple") && url.includes("music"))
    return { Icon: AppleMusic, label: "Apple Music" };
  if (url.includes("deezer")) return { Icon: Deezer, label: "Deezer" };
  if (url.includes("tidal")) return { Icon: Tidal, label: "Tidal" };
  if (url.includes("last.fm") || url.includes("lastfm"))
    return { Icon: LastFm, label: "Last.fm" };
  if (url.includes("musicbrainz"))
    return { Icon: MusicBrainz, label: "MusicBrainz" };
  if (url.includes("wikipedia")) return { Icon: Wikipedia, label: "Wikipedia" };
  if (url.includes("youtube") || url.includes("youtu.be"))
    return { Icon: YouTube, label: "YouTube" };
  return { Icon: Unkown, label: "Website" };
}
